import { Button } from '#app/components/Buttons/Button.js';
import { Grid } from '#app/components/Grid/Grid.js';
import { GridColumn } from '#app/components/Grid/GridColumn.js';
import { Link } from '#app/components/Link/index.js';
import { Text } from '#app/components/Primitives/Text.js';
import { MainLayout } from '#app/layouts/MainLayout/MainLayout.js';
import background404 from './assets/404.webp';
import { css, styled } from 'styled-components';

const PageGrid = styled(Grid)`
  height: 100%;
`;

const ErrorContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    height: 100%;

    padding-bottom: 50%;

    ${theme.mediaQueries.md} {
      padding-bottom: 25%;
    }
  `}
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const NumberText = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colorsV2.black};
    font-weight: 500;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.06em;
    font-size: 24px;

    ${theme.mediaQueries.md} {
      font-size: 40px;
    }
  `}
`;

const Headline = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colorsV2.black};
    font-weight: 500;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.06em;
    width: 100%;

    max-width: 240px;
    font-size: 32px;

    ${theme.mediaQueries.md} {
      font-size: 58px;
      max-width: unset;
    }
  `}
`;

const Prompt = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colorsV2.black};
    display: flex;
    flex-direction: column;
    gap: 4px;

    font-weight: 400;
    text-align: center;
    letter-spacing: -0.25px;
    font-size: 16px;

    ${theme.mediaQueries.md} {
      font-size: 23px;
    }

    a {
      display: block;
      color: ${theme.colorsV2.brandPurple};
      :hover {
        text-decoration-color: ${theme.colorsV2.brandPurple};
      }
    }
  `}
`;

export const NotFound = () => {
  return (
    <MainLayout backgroundImage={background404}>
      <PageGrid>
        <GridColumn
          center
          initial={12}
        >
          <ErrorContent>
            <Section>
              <NumberText>404</NumberText>
              <Headline>Uh oh. This page doesn’t exist.</Headline>
            </Section>
            <Section>
              <Button
                as={Link}
                to="/"
                variant="V2Primary"
              >
                Back to home
              </Button>
            </Section>
            <Section>
              <Prompt>
                Not finding what you’re looking for?
                <a
                  href="mailto:hello@contra.com"
                  rel="noreferrer"
                  target="_blank"
                >
                  Shoot us a message.
                </a>
              </Prompt>
            </Section>
          </ErrorContent>
        </GridColumn>
      </PageGrid>
    </MainLayout>
  );
};
